<template>
  <div class="xl:h-fit" :class="isMonthRank ? 'h-fit' : 'h-[calc(100%-57px)]'">
    <div v-if="listOpen" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"></div>
    <div
        :class="{ 'border-y border-zt-light !rounded-[0px] xl:border-x xl:!rounded-zt' : isMonthRank }"
        class="bg-zt-normal !px-0 rounded-zt pt-6 h-full xl:mt-4">
      <div class="flex flex-col items-center justify-start h-full">
        <div class="flex-1 flex flex-col items-center justify-start w-full">
          <p class="text-2xl relative font-medium z-5">Wybierz miesiąc</p>
          <div class="w-full h-full mx-5 mt-4 xl:mt-5 xl:mx-4">
            <div class="w-full flex justify-center">
              <FootballSelect
                  v-if="selected"
                  class="!w-[calc(100%-36px)] xl:max-w-[350px]"
                  v-model="selected"
                  mobile-full-screen
                  :options="dropList"
              />
            </div>
            <div
                :class="{ '-mx-3' : !isMonthRank }"
                class="border-b border-[#344153] mt-5 mb-6 xl:mx-0"></div>
            <p class="text-2xl w-fit mx-auto !my-5 relative font-medium z-5 xl:mt-6">Wybierz ranking</p>
            <rank v-if="ranking.year" :is-month-rank="isMonthRank" :is-sidebar="false" :edition="ranking" @close-modal="closeModal"/>
          </div>
        </div>
        <div v-if="window.size.mobile && !isMonthRank"
             class="w-[calc(100%-40px)] mx-5 pb-4">
          <button class="w-full py-3 bg-zt-light border-zt-light rounded-zt zt-hover"
	                @click.stop="closeModal()">
            <span class="text-sm font-semibold">ZAMKNIJ OKNO</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import FormSelect from '../FormSelect.vue';
import FootballSelect from "../FootballSelect.vue";

export default {
  components: {
    FootballSelect,
    rank: defineAsyncComponent(() => import('../Rankings.vue')),
    FormSelect,
  },
  props: {
    isMonthRank: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
      default: null
    },
    month: {
      type: Number,
      default: null
    }
  },
  name: 'Rankings',
  inject: ['WP'],
  emits: ['close-modal'],
  activated() {
    if (this.isMonthRank) {
      return;
    }
    if (window.size.desktop && window.scrollY > 120 && !(this.WP.id === 129244)) {
      window.scrollTo(0, 120);
    }
    document.getElementById('betting-container').style.height = 'auto';
  },
  mounted() {
    this.getCurrentEditionNumber()
    if (this.year && this.month) {
      this.ranking.month = this.year;
      this.ranking.year = this.month;
    } else {
      this.ranking.month = new Date().getMonth();
      this.ranking.year = new Date().getFullYear();
    }
    this.getDropList();
    this.setDate();
    this.emitter.on('bettingTipsModalCloseButtonClicked', this.closeModal);
  },
  data() {
    return {
      bestCurrentUsers: [],
      rankingHistory: [],
      ranking: {
        month: null,
        year: null
      },
      firstEditionMonth: 3,
      firstEditionYear: 2022,
      editions: null,
      details: null,
      dropList: [],
      selected: '',
      isUserWithAdminPanel: this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor',
      clickOutside: {
        handler: () => { this.listOpen = false },
        events: ['touchend', 'mouseup']
      },
      listOpen: false
    };
  },
  methods: {
    setDate() {
      if (this.year && this.month) {
        const date = `01-${this.month}-${this.year}`;
        const fullMonth = DateTime.fromFormat(`${date}`, 'dd-M-yyyy', { locale: 'pl' }).toFormat('LLLL');
        const dateToSearch = fullMonth.capitalize() + ' ' + this.year;
        this.selected = dateToSearch;
        return;
      }
      this.selected = this.dropList[0];
    },
    getMonth(edition) {
      let month = new Date().getMonth() + 1 - (edition % 12);
      return (month = month > 0 ? month : 12 + month);
    },
    getYear(edition) {
      let date = new Date();
      let year = date.getMonth() + 1 - edition;
      return date.getFullYear() - (year <= 0 ? Math.floor(Math.abs(year) / 12) + 1 : 0);
    },
    getCurrentEditionNumber() {
      let date = new Date();
      this.editions = (date.getFullYear() - this.firstEditionYear) * 12 + (date.getMonth() + 1 - this.firstEditionMonth) + 4;
      return this.editions;
    },
    getMonthName(number) {
      let months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
      return months[number - 1];
    },
    getEditionString(number) {
      let date = new Date();
      if (number - this.editions === 0) {
        return this.getMonthName(date.getMonth()) + date.getFullYear();
      } else {
        let month = date.getMonth() + 1 - (number % 12);
        let year = date.getMonth() + 1 - number;
        month = month > 0 ? month : 12 + month;
        year = date.getFullYear() - (year <= 0 ? Math.floor(Math.abs(year) / 12) + 1 : 0);
        return this.getMonthName(month) + ' ' + year;
      }
    },
    //NIE USUWAC MOZE BYC POTRZEBNE DO STARYCH RANKINGOW

    // getRankingHistory() {
    //   axios
    //     .post(this.WP.ajaxUrl, {
    //       endpoint: 'api_get_td_winners_history',
    //       month: this.ranking.month,
    //       year: this.ranking.year,
    //       count: 5
    //     })
    //     .then(response => {
    //       if (response.data.success === false) {
    //         this.rankingHistory = [];
    //         this.details = null;
    //       }
    //       if (response.data.data.winners) {
    //         this.rankingHistory = response.data.data.winners;
    //         this.details = response.data.data.link;
    //       }
    //     });
    // },
    getDropList() {
      for (let i = 0; i < this.editions - 4; i++){
        this.dropList.push(this.getEditionString(i));
      }
    },
    closeModal() {
      this.$emit('close-modal');
    }
  },
  watch: {
    selected: {
      handler() {
        let index = this.dropList.findIndex((el) => this.selected === el);
        if (index !== -1) {
          this.ranking.month = this.getMonth(index);
          this.ranking.year = this.getYear(index);
          // this.getRankingHistory();
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped>
h1 {
  @apply my-0 !important;
}

* {
  ::-webkit-scrollbar {
    @apply w-[5px] h-[2px] xl:w-[7px] xl:h-[15px];
  }
  ::-webkit-scrollbar-track {
    @apply bg-[#2C394B] xl:bg-transparent;
  }
  ::-webkit-scrollbar-thumb {
    @apply bg-white/30 border-[5px] border-zt-more rounded-[6.25rem] bg-clip-content xl:border-transparent xl:border-[1px] xl:border-solid;
  }
}
</style>
